import { Application } from "../../System/Application/Application";

export function PDFViewer(props) {
    return (
        <Application {...props}>
            <embed
                src={props.args.url}
                type="application/pdf"
                width="100%"
                height="100%"
                style={{ border: "none" }}
            />
        </Application>
    );
}
